'use strict';

(function (w, d) {
    var timer;
    var timeout = 300; // timeout to close flyouts, in ms.
    var current;
	var isOpenClass = 'is-open';
    var isActiveClass = 'is-active';
	var hasOverlayClass = 'has-menu-overlay';
    var isMobile = false;

    var HeaderNav = w.HeaderNav = {};
    var ToggleMenu = w.ToggleMenu = {};

    HeaderNav.init = function () {
        var nav = d.querySelector('[data-headernav]');

        if (nav) {
            // Find items containing submenus.
            var items = nav.querySelectorAll('.menu-item-has-children');

            [...items].forEach(function (item) {
                item.addEventListener('mouseenter', function(e) {
                    if (isMobile) return;
                    clearTimeout(timer);
                    if (current && current != this) {
                        clearCurrent();
                    }
					setCurrent(this);
                });
                item.addEventListener('mouseleave', function(e) {
                    if (isMobile) return;
                    timer = setTimeout(clearCurrent, timeout);
                });
                const button = item.querySelector('button');
                button?.addEventListener('touchstart', setMobile, {passive: true});
                button?.addEventListener('click', function(e) {
                    const item = this.closest('li');
                    if (current && current == item) {
                        clearCurrent();
                    } else {
                        clearCurrent();
                        setCurrent(item);
                    }
                });
            });
        }
    };

    ToggleMenu.init = function() {
        var menu = document.querySelector('.main-nav');
        document
            .querySelector('.menu-toggle')
            .addEventListener('click', function(e) {
                this.classList.toggle(isActiveClass);
                menu.classList.toggle(isOpenClass);
                d.body.classList.toggle(hasOverlayClass);
            });
    };

    function clearCurrent(keepOverlay) {
        current?.classList.remove(isOpenClass);
        current = null;
        if (!isMobile) d.body.classList.remove(hasOverlayClass);
    }

	function setCurrent(menuItem) {
		menuItem.classList.add(isOpenClass);
        current = menuItem;
		d.body.classList.add(hasOverlayClass);
	}

    function setMobile() {
        isMobile = true;
    }

    d.addEventListener('DOMContentLoaded', HeaderNav.init);
    d.addEventListener('DOMContentLoaded', ToggleMenu.init);


})(window, document);
